import { MarketplaceCardMedium } from 'marketplace-embed/js/components/MarketplaceCardMedium';
import { useUsageTracker } from 'marketplace-ui-tracking';
import { generatePath, useHistory } from 'quartz-routing/react-router';
import * as t from 'ts-schema';
import { Paths } from '../../constants/paths';
import { jsx as _jsx } from "react/jsx-runtime";
export function StorefrontListingCard({
  listing,
  collectionId,
  collectionSlug,
  context,
  pageNumber,
  queryType,
  resultCount,
  resultIndex,
  searchTerm,
  section
}) {
  const tracker = useUsageTracker();
  const history = useHistory();
  const product = listing.products[0];
  const pathTemplate = product.productType === 'SOLUTIONS_PARTNER_PROFILE' ? Paths.SOLUTIONS_PARTNERS_DETAILS : Paths.LISTING_DETAILS;
  const listingHref = generatePath(pathTemplate, {
    listingSlug: t.assert(t.string, listing.slug)
  });
  return /*#__PURE__*/_jsx(MarketplaceCardMedium, {
    listing: listing,
    onClick: () => history.push(listingHref),
    tracker: tracker,
    trackingProps: {
      collectionId,
      collectionSlug,
      pageNumber,
      queryType,
      resultCount,
      resultIndex,
      search: searchTerm,
      section,
      value: context === null || context === void 0 ? void 0 : context.value
    }
  });
}